import React from 'react';

interface ActionButton {
  label: string;
  onClick: () => void;
  variant?: 'primary' | 'success' | 'info' | 'danger';
  icon?: React.ReactNode;
}

interface PageHeaderProps {
  title: string;
  description?: string;
  actions?: ActionButton[];
  children?: React.ReactNode;
}

const variantClasses: Record<string, string> = {
  primary: 'bg-ocean-600 text-white hover:bg-ocean-700 focus:ring-ocean-500',
  success: 'bg-green-600 text-white hover:bg-green-700 focus:ring-green-500',
  info: 'bg-blue-600 text-white hover:bg-blue-700 focus:ring-blue-500',
  danger: 'bg-red-600 text-white hover:bg-red-700 focus:ring-red-500',
};

const PageHeader: React.FC<PageHeaderProps> = ({ title, description, actions, children }) => (
  <div className="flex items-center justify-between">
    <div>
      <h1 className="text-2xl font-bold text-gray-900">{title}</h1>
      {description && <p className="text-gray-600">{description}</p>}
    </div>
    {(actions || children) && (
      <div className="flex items-center gap-3">
        {actions?.map((action, i) => (
          <button
            key={i}
            onClick={action.onClick}
            className={`px-4 py-2 rounded-md focus:outline-none focus:ring-2 transition-colors flex items-center space-x-2 ${
              variantClasses[action.variant || 'primary']
            }`}
          >
            {action.icon}
            <span>{action.label}</span>
          </button>
        ))}
        {children}
      </div>
    )}
  </div>
);

export default PageHeader;